import { useEffect, useState, useContext } from "react";
import Context from "../../storage/context";
import axios from "axios";

const css = `
@import url('https://fonts.googleapis.com/css2?family=Heebo:wght@400;600;700;800;900&display=swap');

.del-overlay {
  position: fixed; inset: 0; z-index: 2000;
  background: rgba(3,7,15,0);
  display: flex; align-items: center; justify-content: center;
  padding: 20px; pointer-events: none;
  transition: background .3s ease;
  font-family: 'Heebo', sans-serif; direction: rtl;
}
.del-overlay.open {
  pointer-events: all;
  background: rgba(3,7,15,0.85);
  backdrop-filter: blur(6px);
}
.re-modal {
  background: #0b1622;
  border: 1px solid rgba(201,168,76,.2);
  border-radius: 20px;
  box-shadow: 0 32px 80px rgba(0,0,0,.7);
  padding: 32px 28px 28px;
  width: 100%; max-width: 600px;
  transform: scale(0.75) translateY(30px);
  opacity: 0;
  transition: transform .35s cubic-bezier(.22,1,.36,1), opacity .28s ease;
  text-align: center;
}
.del-overlay.open .re-modal{ transform: scale(1) translateY(0); opacity: 1; }
.del-icon {
  width: 60px; height: 60px; border-radius: 50%;
  background: rgba(224,82,82,.1); border: 2px solid rgba(224,82,82,.3);
  display: flex; align-items: center; justify-content: center;
  margin: 0 auto 20px; font-size: 26px;
}
.del-title { font-size: 20px; font-weight: 900; color: #edf0f5; margin-bottom: 10px; }
.del-msg { font-size: 14px; color: #8da0b8; line-height: 1.6; margin-bottom: 28px; }
.del-msg strong { color: #edf0f5; font-weight: 700; }
.del-divider { height: 1px; background: rgba(255,255,255,.06); margin-bottom: 24px; }
.del-btns { display: grid; grid-template-columns: 1fr 1fr; gap: 10px; }
.del-btn {
  padding: 13px 0; border-radius: 10px;
  font-family: 'Heebo', sans-serif; font-size: 15px; font-weight: 800;
  cursor: pointer; transition: all .2s; border: none;
}
.del-btn--yes {
  background: linear-gradient(135deg, #e05252, #b83333);
  color: #fff; box-shadow: 0 4px 16px rgba(224,82,82,.3);
}
.del-btn--yes:hover { transform: translateY(-1px); box-shadow: 0 8px 24px rgba(224,82,82,.45); }
.del-btn--no {
  background: rgba(255,255,255,.05);
  border: 1px solid rgba(255,255,255,.1) !important;
  color: #8da0b8;
}
.del-btn--no:hover { background: rgba(255,255,255,.09); color: #edf0f5; }

.input-error {
    border: 2px solid #ff4d4d !important; /* אדום בולט */
    outline: none !important;
    background-color: rgba(255, 77, 77, 0.05) !important;
}

.input-error:focus {
    border-color: #ff4d4d !important;
    box-shadow: 0 0 8px rgba(255, 77, 77, 0.2) !important;
}
`;

export default function PadingReview({ open, onClose, lastID }) {
    const [showErrors, setShowErrors] = useState(false);
    const [newReview, setNewReview] = useState({
        id: lastID + 1,
        name: "",
        city: "",
        text: "",
        rating: 5,
        date: new Date().toISOString().split("T")[0]
    });
    let ctx = useContext(Context);


    const [isSubmitted, setIsSubmitted] = useState(false);

    useEffect(() => {
        const fn = (e) => e.key === "Escape" && onClose();
        if (open) {
            window.addEventListener("keydown", fn);
            setIsSubmitted(false);
        }
        return () => window.removeEventListener("keydown", fn);
    }, [open, onClose]);

    useEffect(() => {
        document.body.style.overflow = open ? "hidden" : "";
        return () => { document.body.style.overflow = ""; };
    }, [open]);


    const onConfirmReview = async (e) => {
        if (e) e.preventDefault();

        const name = newReview?.name?.trim() || "";
        const text = newReview?.text?.trim() || "";

        if (!name || !text) {
            console.log("עוצר: שדות חובה ריקים");
            setShowErrors(true);
            return;
        }

        try {
            const response = await axios.post(`${ctx.api_url}/add-pending-review`, {
                ...newReview,
                name: name,
                text: text
            });

            if (response.status === 200) {
                setIsSubmitted(true);
                setShowErrors(false);

                setTimeout(() => {
                    onClose();
                }, 3000);
            }
        } catch (err) {
        }
    };

    return (
        <>
            <style>{css}</style>
            <div className={`del-overlay${open ? " open" : ""}`} onClick={onClose}>
                <div className="re-modal" onClick={(e) => e.stopPropagation()}>
                    {!isSubmitted ? (
                        <>
                            <div className="del-title">הוספת ביקורת</div>
                            <div className="form-grid" style={{ display: 'grid', gap: '10px', textAlign: 'right' }}>
                                <input
                                    type="text"
                                    placeholder="שם *"
                                    className={`custom-input ${showErrors && !newReview.name.trim() ? "input-error" : ""}`}
                                    value={newReview.name}
                                    onChange={e => setNewReview({ ...newReview, name: e.target.value })}
                                />
                                <input
                                    type="text"
                                    placeholder="עיר"
                                    value={newReview.city}
                                    onChange={e => setNewReview({ ...newReview, city: e.target.value })}
                                />
                                <input
                                    type="date"
                                    value={newReview.date}
                                    onChange={e => setNewReview({ ...newReview, date: e.target.value })}
                                    disabled={true}
                                />
                                <select
                                    value={newReview.rating}
                                    onChange={e => setNewReview({ ...newReview, rating: Number(e.target.value) })}
                                    className="rating-select"
                                >
                                    {[5, 4, 3, 2, 1].map(r => (
                                        <option key={r} value={r}>{r} ⭐</option>
                                    ))}
                                </select>
                                <textarea
                                    placeholder="טקסט הביקורת *"
                                    className={`review-textarea ${showErrors && !newReview.text.trim() ? "input-error" : ""}`}
                                    value={newReview.text}
                                    onChange={e => setNewReview({ ...newReview, text: e.target.value })}
                                    rows={3}
                                />
                            </div>
                            <div className="del-divider" />
                            <div className="del-btns">
                                <button className="del-btn del-btn--yes" onClick={(e) => onConfirmReview(e)}>
                                    שלח לאישור
                                </button>
                                <button className="del-btn del-btn--no" onClick={onClose}>
                                    ביטול
                                </button>
                            </div>
                        </>
                    ) : (
                        <div style={{ padding: '40px 0' }}>
                            <div className="del-icon" style={{ background: 'rgba(76, 201, 132, 0.1)', borderColor: '#4cc984', color: '#4cc984' }}>
                                ✓
                            </div>
                            <div className="del-title">תודה רבה!</div>
                            <div className="del-msg">
                                הביקורת שלך עברה ל<strong>מנהל האתר</strong> לאישור.<br />
                                היא תופיע באתר בקרוב.
                            </div>
                            <div style={{ color: '#8da0b8', fontSize: '12px', marginTop: '10px' }}>
                                המודאל ייסגר אוטומטית בעוד מספר שניות...
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </>
    );
}
